<script lang="ts">
	import { browser } from '$app/environment';
	import { m } from '$lib/paraglide/messages';
	import { fly } from 'svelte/transition';

	let scrollY = $state(0);

	// Show button when user scrolls down 200px
	let isVisible = $derived(scrollY > 200 && document.documentElement.style.overflow !== 'hidden');

	function scrollToTop() {
		if (browser) {
			window.scrollTo({
				top: 0,
				behavior: 'smooth',
			});
		}
	}
</script>

<svelte:window bind:scrollY />

{#if isVisible}
	<button
		transition:fly={{ y: 20, duration: 300 }}
		onclick={scrollToTop}
		class="fixed right-6 bottom-6 z-10 flex h-12 w-12 cursor-pointer items-center justify-center rounded-full bg-neutral-900 text-white shadow-lg transition-all duration-300 hover:bg-neutral-700 hover:shadow-xl focus:ring-2 focus:ring-neutral-500 focus:ring-offset-2 focus:outline-none"
		aria-label={m.back_to_top()}
		title={m.back_to_top()}
	>
		<span class="icon-[mdi--arrow-up] size-6"></span>
	</button>
{/if}
